import React from "react";
import {Container} from "reactstrap";

const Page = ({ children }) => {
    return (
        <>
            <div className="page-content" style={{marginBottom: 50}}>
                <Container fluid>
                    <div className="main_freight_wrapper">
                        {children}
                    </div>
                </Container>
            </div>
        </>
    )
}

export default Page;
